import React, { useRef } from 'react';
import BordOneToneIcon from '../../BordOneToneIcon/BordOneToneIcon';
import './CommentImageUploadButton.scss';

const CommentImageUploadButton = ({
  showUploadImageModal,
  setShowUploadImageModal,
  handleFileChange,
  imageModalRef,
  imagePreview,
  handleRemoveImage,
  isLoading
}: CommentImageUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleOpenModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isLoading) return;
    setShowUploadImageModal(!showUploadImageModal);
  };

  if (imagePreview) {
    return (
      <div className="bordMentionsImagePreview">
        <img src={imagePreview} alt="image in comment input preview" />
        <div className={`bordMentionsRemoveImage ${isLoading ? 'isDisabled' : ''}`} onClick={handleRemoveImage}>
          <BordOneToneIcon variant="trash2" customWidth="10px" stroke="white" />
        </div>
      </div>
    );
  }

  return (
    <div className="bordMentionsActions">
      <button onClick={handleOpenModal}>
        <BordOneToneIcon variant={showUploadImageModal ? 'x' : 'plus'} customWidth="12px" className="actionButton" />
      </button>
      {showUploadImageModal && (
        <div ref={imageModalRef} className="bordMentionsImageModal" onClick={() => fileInputRef.current?.click()}>
          <BordOneToneIcon variant="image" customWidth="12px" stroke="black" />
          Cargar imagen
        </div>
      )}
      <input ref={fileInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFileChange} />
    </div>
  );
};

export default CommentImageUploadButton;

export interface CommentImageUploadButtonProps {
  showUploadImageModal: boolean;
  setShowUploadImageModal: (show: boolean) => void;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  imageModalRef: React.RefObject<HTMLDivElement>;
  imagePreview: string | null;
  handleRemoveImage: () => void;
  isLoading?: boolean;
}
